export const getBuilderAttributes = (component = {}) => {
  const attributes = {};

  if (
    component?._id !== undefined &&
    component?._id !== null &&
    component?._id !== ""
  ) {
    attributes["data-builder-id"] = component._id;
  }

  if (
    component?.type !== undefined &&
    component?.type !== null &&
    component?.type !== ""
  ) {
    attributes["data-builder-type"] = component.type;
  }

  return attributes;
};
